<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item' :template-data='templateData'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:loading="formLoading" size="large" type="primary"> 核价确认
		</Button>
		<Button class="submit-process" v-on:click='refuse' v-bind:loading="formLoading" size="large" type="primary"> 驳回
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess,
		getFlowTemplate,
		sendMessage,
		GetPendingProcessById
	} from '@/api/approval'
	import {
		getRelation
	} from '@/api/employee'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	const sendMessagetTemplate = {
	  title: null,
	  url: null,
	  toUser: [],
	  desc: null,
	  template: null,
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				formLoading: false,
				listLoading: false,
				flowId:null,
				applyTemplateData:null,
				applicant:null,
				sendMessageData: Object.assign({},sendMessagetTemplate)
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.flowId = this.$route.query.flowId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
			stringUtils.setAddIsShow(true);
		},
		methods: { //方法
			
			clickChoose(dataVal, name) {
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var depart = res.result.departmentList[0]; // 已选的部门列表
						dataVal.Values=[];
						dataVal.Values.push([depart.id,depart.name]);
						dataVal.Value = depart.name;
					}
				})
			},
			getFlowTemplateInfo: async function() {
				if(this.flowId==null||this.flowId==undefined||this.flowId.length<=0){
						return;
				}
				await getFlowTemplate(this.flowId).then(response => {
					this.applyTemplateData = response.Body;
				});
			},
			getTemplate: async function() {
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var jobLevel = this.logInfo.JobLevel;
				await GetPendingProcessById(this.flowId).then(response =>{
					if(response.Body==null){
						this.Message({
							message: '该流程已经处理完成',
							type: 'success',
							duration: 3 * 1000
						});
						setTimeout(() => {
							this.$router.push("/Pricing");
						}, 1000)
						return;
					}
				})
				await this.getFlowTemplateInfo();
				
				await getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					var pageTable=controls.TemplateContent.Controls.filter(t=>{return t.Property.Control=="Table"})[0]
					var applyTableList=this.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Control=="Table"});
					pageTable.Id="Table-"+this.guid();
					for(var i=1;i<applyTableList.length;i++){
						pageTable.deleteIsShow=true;
						var control = JSON.stringify(pageTable);
						control = JSON.parse(control);
						control.Id="Table-"+this.guid();
						control.deleteIsShow=true;
						control.Property.Title[0].Text="申请项目内容"+i;
						controls.TemplateContent.Controls.splice(7+i,0,control);
					}
					await this.getEmployeeRelation();
					controls.TemplateContent.Controls.forEach((item) => {
						var departs = this.logInfo.fullName.split("/");
						if (item.Property.Title[0].Text == "填表日期") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "核价人员") {
							item.Disable = true;
							item.Value=this.logInfo.EmpName;
						}
						if (item.Property.Title[0].Text == "申请人员") {
							item.Disable = true;
							if(this.applyTemplateData!=null){
								var empName=this.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "人员"})[0].Value;
								var empNo=this.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "工号"})[0].Value;
								item.Values=[[empNo,empName]];
								item.Value=empName;
								this.applicant=empNo;
							}
						}
						if (item.Property.Title[0].Text == "申请部门") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "申请原因") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "类别") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "区域董事") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "部门直属主管") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "部门总监总经理") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "大区董事") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "大区总经理") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "所在部门") {
							item.Disable = true;
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "小计") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "合计") {
							item.Disable = true;
						}

					});
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, null,this.flowId);
					this.listLoading = false;
				});

			},
			getEmployeeRelation: async function() {
				await getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {},
			tableOperation(val, type, datas) {
				if(type=='compute'){
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			refuse(){
				var controls = this.templateData.TemplateContent.Controls;
				var applyEmpNo = '';
				controls.forEach(e =>{
					if (e.Property.Title[0].Text == "申请人员") {
						applyEmpNo = e.Values[0][0];
					}
				})
				this.sendMessageData.template=this.templateData;
				this.sendMessageData.title="工程预算申请";
				this.sendMessageData.toUser=[applyEmpNo];
				this.sendMessageData.desc="驳回人员："+this.logInfo.EmpName;
				this.sendMessageData.url=document.location.hostname+"/projectBudget?templateId=3TmBHTkZd3WDnwqkKnSctPUDFthDzKe8XJ14V77u&flowId="+this.flowId;
				//提交
				sendMessage(this.templateId, this.logInfo.EmpNo, this.spNo, this.sendMessageData,2,"",this.flowId).then(response => {
					this.Message({
						message: '驳回成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
				});
			},
			submit() {
				var sumPrice=this.templateData.TemplateContent.Controls.filter(item=>{return item.Property.Title[0].Text == "合计"})[0].Value
				this.templateData.TemplateContent.Controls.forEach(item=>{
					
					if(item.Property.Title[0].Text == "申请项目合计"){
						item.Value=sumPrice
					}
					var price=null;
					if(item.Property.Control=="Table"){
						item.Config.Table.Children.forEach(childItem=>{
							if(childItem.Property.Title[0].Text == "小计"){
							   price=childItem.Value;
							}
							if(childItem.Property.Title[0].Text == "申请项目小计"){
							   childItem.Value=price
							   price=null;
							}
							
						});
					}
				})
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				
				// 1、申请人信息：申请人姓名+工号+部门名称
				// 2、申请部门：申请部门
				// 3、核价金额：价格确认XX元
				
				var SummaryList = [];
				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请人员"})[0]
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请部门"})[0]
				
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请人信息："+control1.Values[0][1]+"   "+control1.Values[0][0]+"   "+control3.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请部门："+control3.Values[0][1],"Lang":"zh_CN"});
				SummaryList.push(info);
				
				
				var control4=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "费用核价"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"核价金额："+control4.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				
				this.templateData.SummaryList=SummaryList
				
				
				isSubmit = true;
				this.listLoading = true;
				//提交
				submitProcess(this.templateId, this.applicant, this.spNo, this.templateData,this.flowId).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/Pricing");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
				});
			}
		}

	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
